type JwtClaims = Record<string, unknown>

function decodeBase64Url(segment: string): string {
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(
        base64.length + ((4 - (base64.length % 4)) % 4),
        '='
    )
    const binary = atob(padded)
    if (typeof TextDecoder === 'undefined') {
        return binary
    }
    return new TextDecoder().decode(
        Uint8Array.from(binary, (char) => char.charCodeAt(0))
    )
}

/**
 * Unverified read of a JWT payload. Only for noticing identity changes on
 * this side; authorization decisions stay with the server that signed it.
 */
export function readJwtClaims(token: string | null): JwtClaims | null {
    const payload = token?.split('.')[1]
    if (!payload) {
        return null
    }
    try {
        const claims: unknown = JSON.parse(decodeBase64Url(payload))
        return claims !== null && typeof claims === 'object'
            ? (claims as JwtClaims)
            : null
    } catch {
        return null
    }
}

export function readJwtUserId(token: string | null): string | null {
    const claims = readJwtClaims(token)
    const userId = claims?.user_id ?? claims?.sub
    return userId === undefined || userId === null ? null : String(userId)
}
